import { createContext, useContext } from 'react';
import type { Session } from '@supabase/supabase-js';

export type WalletProfile = {
  id: string;
  username: string | null;
  nickname: string | null;
  wallet_address: string | null;
  last_auth_method: string | null;
};

export type AuthContextValue = {
  session: Session | null;
  profile: WalletProfile | null;
  isLoading: boolean;
  isSigningIn: boolean;
  isWorldApp: boolean;
  error: string | null;
  signIn: () => Promise<void>;
  signOut: () => Promise<void>;
  clearError: () => void;
};

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth 必須在 AuthProvider 內使用。');
  }
  return context;
}
